export type UltraDebugPayload = {
  debug?: any;
  dnaCoverage?: any;
  knowledgeGaps?: any;
  updatedAt?: string;
};

type Listener = () => void;

const state = {
  payload: null as UltraDebugPayload | null,
  listeners: new Set<Listener>(),
};

const notify = () => {
  state.listeners.forEach(cb => cb());
};

export const ultraDebugStore = {
  subscribe(cb: Listener) {
    state.listeners.add(cb);
    return () => state.listeners.delete(cb);
  },
  getSnapshot() {
    return state.payload;
  },
  setPayload(payload: UltraDebugPayload) {
    state.payload = {
      ...payload,
      updatedAt: new Date().toISOString(),
    };
    notify();
  },
  clear() {
    state.payload = null;
    notify();
  },
};
